module.exports = __webpack_public_path__ + "img/40800.7cad6a27.jpg";